// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".config-selection-title[data-v-905529cc] {\n  font-weight: 500;\n}\n.config-selection-subtitle[data-v-905529cc] {\n  font-size: 10px;\n  color: #A6A4A6;\n}", ""]);
// Exports
module.exports = exports;
